import { render, staticRenderFns } from "./QuestiontypeEdit.vue?vue&type=template&id=6fb738d6&"
import script from "./QuestiontypeEdit.vue?vue&type=script&lang=ts&"
export * from "./QuestiontypeEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6fb738d6')) {
      api.createRecord('6fb738d6', component.options)
    } else {
      api.reload('6fb738d6', component.options)
    }
    module.hot.accept("./QuestiontypeEdit.vue?vue&type=template&id=6fb738d6&", function () {
      api.rerender('6fb738d6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/configuration/questionType/QuestiontypeEdit.vue"
export default component.exports